import React, {Component} from 'react';

import { Grid, TextField, Typography, Button } from '@material-ui/core';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { resetPasswordConfirm } from '../../actions/ResetPassword/index.js';

class ChangePasswordFormCmp extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email: '',
            newPassword: '',
            token: props.token
        }
    }

    handleChange(event) {
        this.setState({ [event.target.name]: event.target.value });
    }

    handleSubmit(event) {
        event.preventDefault();
        this.props.resetPasswordConfirm(this.state.email, this.state.newPassword, this.state.token);
    }

    render() {
        return (
            <div>
                <Grid container item justify="center">
                    <TextField
                        id="outlined-email-input"
                        label="Email"
                        type="email"
                        name="email"
                        autoComplete="email"
                        margin="normal"
                        variant="outlined"
                        fullWidth
                        onChange={this.handleChange.bind(this)}
                    />
                </Grid>
                <Grid container item justify="center">
                    <TextField
                        id="outlined-password-input"
                        label="New Password"
                        name="newPassword"
                        type="password"
                        margin="normal"
                        variant="outlined"
                        fullWidth
                        onChange={this.handleChange.bind(this)}
                    />
                </Grid>
                <Button fullWidth variant="contained" color="primary" size="large" onClick={this.handleSubmit.bind(this)}>
                    Change Password
                </Button>
                {this.props.errorMessage &&
                    <Grid container item>
                        <Typography variant="overline" color="error">{this.props.errorMessage}</Typography>
                    </Grid>
                }
            </div>
        );
    }
};

function mapStateToProps(state, ownProps) {
    return {
    };
}
function matchDispatchToProps(dispatch) {
    return bindActionCreators({
        resetPasswordConfirm
    }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(ChangePasswordFormCmp);
